import { useEffect } from "react"
import { _single, _WorkActivityPriority } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import useModal, { MODAL_LG, MODAL_SM } from "../../theme/Component/hooks/useModal"
import { toast } from "react-toastify"
import { ListMenu } from "../../theme/Component/ListMenu"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BasicTable } from "../../theme/Component/BasicTable"
import { Modal } from "../../theme/Component/Modal"
import { ModalConfirm } from "../../theme/Component/ModalConfirm"

export const WorkActivityPriority = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivityPriority)

    const modal = useModal("", MODAL_LG);
    const modalC = useModal("Eliminar prioridad de Actividad", MODAL_SM);


    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getWorkActivityPriorityCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de prioridades");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Agregar Prioridad de Actividades")
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateWorkActivityPriority(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close()
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDWorkActivityPriority', visible: true },
        { title: 'Nombre de la Prioridad', property: 'PriorityName', visible: true },
        { title: 'Descripción', property: 'PriorityDescription', visible: true },
        { title: 'Valor de la prioridad', property: 'PriorityValue', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar prioridad ${bean.PriorityName}`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Prioridades de las Actividades">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Nombre de la Prioridad</label>
                                <input type="text" className="form-control" value={bean.PriorityName} onChange={(e) => { setBean({ ...bean, PriorityName: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label>Valor de la Prioridad</label>
                                <input type="number" className="form-control" value={bean.PriorityValue} onChange={(e) => {
                                    const valor = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, PriorityValue: valor })
                                }} />
                            </div>

                            <div className="col-md-12">
                                <label>Descripción de la Prioridad</label>
                                <textarea className="form-control" value={bean.PriorityDescription} onChange={(e) => { setBean({ ...bean, PriorityDescription: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.PriorityName}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}